import moment from 'moment'
import { CONTENTTYPES, CONFIG } from './constants'
import { uidToUrl } from './helpers'
import { ENGINE_METHOD_DIGESTS } from 'constants'

// ---------------------------------------------------------------------
// HOME
// ---------------------------------------------------------------------

export const mapHome = data => {
  const home = data.home.data
  const services = data.services
  const methods = data.methods

  return {
    hero: {
      logo: {
        url: home.logo.url,
        sizes: home.logo.localFile
          ? home.logo.localFile.childImageSharp.sizes
          : {},
        src: home.logo.localFile
          ? home.logo.localFile.childImageSharp.original.src
          : {},
      },
      tagline: home.tagline,
      video_bg: home.hero_videos
        ? mapVideo(home.hero_videos.document[0].data)
        : {},
    },
    method: {
      title: home.method_title,
      subtitle: home.method_subtitle,
    },
    methods: methods.edges.filter((f) => {return (f.node.uid === 'ct-method-taas' || f.node.uid === 'ct-method-fixed')}).map(method => {
      return {
        uid: method.node.uid,
        title: method.node.data.headline,
        subtitle: method.node.data.subtitle,
      }
    }),
    video: {
      title: home.featured_video_title,
      subtitle: home.featured_video_subtitle,
      videos: home.featured_video
        ? mapVideo(home.featured_video.document[0].data)
        : {},
    },
    lead: {
      title: home.lead_text,
      subtitle: home.lead_subtitle,
    },
    services: services.edges.map(service => {
      return {
        uid: service.node.uid,
        title: service.node.data.service_headline,
        subtitle: service.node.data.service_subtitle,
        logo: {
          alt: service.node.data.logo.alt,
          url: service.node.data.logo.url,
          src: service.node.data.logo.localFile
            ? service.node.data.logo.localFile.childImageSharp.original.src
            : {},
          sizes: service.node.data.logo.localFile
            ? service.node.data.logo.localFile.childImageSharp.sizes
            : {},
        },
      }
    }),
    body: home.body.map(content => {
      return {
        type: content.slice_type,
        primary: content.primary && content.primary,
        content: content.items.map(item => {
          switch (content.slice_type) {
            case 'featured_blogs': {
              return mapPost(item.blog.document[0], true)
            }
            case 'featured_studies': {
              return mapStudy(item.study.document[0], true)
            }
            case 'featured_careers': {
              return mapCareer(item.career.document[0])
            }
            case 'featured_clients': {
              return mapCustomer(item.customer.document[0])
            }
          }
        }),
      }
    }),
  }
}

// ---------------------------------------------------------------------
// SERVICE
// ---------------------------------------------------------------------

export const mapServices = data => {
  return data.edges.map(item => {
    return mapService(item.node)
  })
}

export const mapService = (service, summary = false) => {
  return {
    uid: service.uid,
    // logo: {
    //   alt: service.data.logo.alt,
    //   sizes: service.data.logo.localFile
    //     ? service.data.logo.localFile.childImageSharp.sizes
    //     : {},
    // },
    logo: {
      alt: service.data.logo.alt,
      src: service.data.logo.localFile
        ? service.data.logo.localFile.childImageSharp.original.src
        : {},
      sizes: service.data.logo.localFile
        ? service.data.logo.localFile.childImageSharp.sizes
        : {},
    },
    // banner: {
    //   alt: service.data.banner_logo.alt,
    //   url: service.data.banner_logo.url,
    //   sizes: service.data.banner_logo.localFile
    //     ? service.data.banner_logo.localFile.childImageSharp.sizes
    //     : {},
    // },
    banner: {
      alt: service.data.banner_logo.alt,
      url: service.data.banner_logo.url,
      src: service.data.banner_logo.localFile
        ? service.data.banner_logo.localFile.childImageSharp.original.src
        : {},
      sizes: service.data.banner_logo.localFile
        ? service.data.banner_logo.localFile.childImageSharp.sizes
        : {},
    },
    service_headline: service.data.service_headline,
    service_subtitle: service.data.service_subtitle,
    lead_title: service.data.lead_title,
    lead_summary: service.data.lead_summary,
    contents: !summary && getContents(service.data),
  }
}

// ---------------------------------------------------------------------
// STUDIES
// ---------------------------------------------------------------------

export const mapStudies = studies => {
  console.log('-------------------------------------------')
  console.log(studies)
  console.log('-------------------------------------------')

  return {
    title: studies.data.title,
    subtitle: studies.data.subtitle,
    // featured_bg: studies.data.featured_study_background,
    featured_bg: {
      alt: studies.data.featured_study_background.alt,
      url: studies.data.featured_study_background.url,
      src: studies.data.featured_study_background.localFile
        ? studies.data.featured_study_background.localFile.childImageSharp
            .original.src
        : {},
    },
    featured_study: studies.data.featured_study.document[0],
    list: studies.data.body.map(study => {
      console.log('>>>>>>>>>>>>>>>>>>>', study)

      switch (study.__typename) {
        case 'PrismicCtStudiesBodyStudyList': {
          return {
            type: study.slice_type,
            contents: study.items.map(study => {
              return {
                slice_type: study.slice_type,
                uid: study.study_existing.document[0].uid,
                // study_bg: study.study_background,
                study_bg: {
                  alt: study.study_background.alt,
                  url: study.study_background.url,
                  src: study.study_background.localFile
                    ? study.study_background.localFile.childImageSharp.original
                        .src
                    : {},
                },
                title: study.study_existing.document[0].data.title,
                subtitle: study.study_existing.document[0].data.subtitle,
                lead: study.study_existing.document[0].data.lead,
                published: friendlyDate(
                  study.study_existing.document[0].data.display_date
                ),
                customer: study.study_existing.document[0].data.customer
                  ? study.study_existing.document[0].data.customer.document[0]
                      .data
                  : null,
              }
            }),
          }
        }
        case 'PrismicCtStudiesBodyStudyQuote': {
          return {
            type: study.slice_type,
            quote: {
              author: study.primary.quote_author,
              quote: study.primary.quote_text,
            },
          }
        }
      }
    }),
  }
}

// ---------------------------------------------------------------------
// STUDY
// ---------------------------------------------------------------------

export const mapStudy = (study, summary = false) => {
  return {
    uid: study.uid,
    tags: study.tags,
    video_bg: study.data.background_videos
      ? mapVideo(study.data.background_videos.document[0].data)
      : {},
    video_fg: study.data.background_videos
      ? mapVideo(study.data.background_videos.document[0].data)
      : {},
    // image: {
    //   alt: study.data.image.alt,
    //   sizes: study.data.image.localFile
    //     ? study.data.image.localFile.childImageSharp.sizes
    //     : {},
    // },
    image: {
      alt: study.data.image.alt,
      sizes: study.data.image.localFile
        ? study.data.image.localFile.childImageSharp.original.src
        : {},
    },
    published: friendlyDate(study.data.display_date),
    title: study.data.title,
    subtitle: study.data.subtitle,
    lead: study.data.lead,
    author: getAuthor(study.data),
    contents: !summary && getContents(study.data),
  }
}

// ---------------------------------------------------------------------
// BLOG
// ---------------------------------------------------------------------

export const mapBlog = blog => {
  return {
    title: blog.data.title,
    subtitle: blog.data.subtitle,
    // featured_bg: blog.data.featured_blog_background,
    featured_bg: {
      alt: blog.data.featured_blog_background.alt,
      url: blog.data.featured_blog_background.url,
      src: blog.data.featured_blog_background.localFile
        ? blog.data.featured_blog_background.localFile.childImageSharp.original
            .src
        : {},
    },
    featured_post: blog.data.featured_blog.document[0],
    list: blog.data.body.map(post => {
      switch (post.__typename) {
        case 'PrismicCtBlogsBodyBlogList': {
          return {
            type: post.slice_type,
            contents: post.items.map(blog_post => {
              return {
                slice_type: post.slice_type,
                uid: blog_post.blog_existing.document[0].uid,
                // post_bg: blog_post.blog_background,
                post_bg: {
                  alt: blog_post.blog_background.alt,
                  url: blog_post.blog_background.url,
                  src: blog_post.blog_background.localFile
                    ? blog_post.blog_background.localFile.childImageSharp
                        .original.src
                    : {},
                },
                title: blog_post.blog_existing.document[0].data.title,
                subtitle: blog_post.blog_existing.document[0].data.subtitle,
                lead: blog_post.blog_existing.document[0].data.lead,
                author:
                  blog_post.blog_existing.document[0].data.author.document[0]
                    .data,
                published: friendlyDate(
                  blog_post.blog_existing.document[0].data.display_date
                ),
              }
            }),
          }
        }
        case 'PrismicCtBlogsBodyBlogQuote': {
          return {
            type: post.slice_type,
            quote: {
              author: post.primary.quote_author,
              quote: post.primary.quote_text,
            },
          }
        }
      }
    }),
  }
}

// ---------------------------------------------------------------------
// POST
// ---------------------------------------------------------------------

export const mapPosts = data => {
  return data.edges.map(item => {
    return mapPost(item.node)
  })
}

export const mapPost = (post, summary = false) => {
  return {
    uid: post.uid,
    tags: post.tags,
    video_bg: post.data.background_videos
      ? mapVideo(post.data.background_videos.document[0].data)
      : {},
    video_fg: post.data.inline_videos
      ? mapVideo(post.data.inline_videos.document[0].data)
      : {},
    image: {
      alt: post.data.image.alt,
      url: post.data.image.url,
      src: post.data.image.localFile
        ? post.data.image.localFile.childImageSharp.original.src
        : {},
    },
    thumbnail: {
      url: post.data.thumbnail.url,
      src: post.data.thumbnail.localFile
        ? post.data.thumbnail.localFile.childImageSharp.original.src
        : {},
    },
    published: friendlyDate(post.data.display_date),
    title: post.data.title,
    subtitle: post.data.subtitle,
    lead: post.data.lead,
    author: getAuthor(post.data),
    contents: !summary && getContents(post.data),
  }
}

// ---------------------------------------------------------------------
// POLICY PAGE
// ---------------------------------------------------------------------

export const mapPolicyPageData = policy => {
  return {
    title: policy.data.title,
    subtitle: policy.data.subtitle,
    image: {
      url: policy.data.image.url,
      sizes: policy.data.image.localFile
        ? policy.data.image.localFile.childImageSharp.sizes
        : {},
      src: policy.data.image.localFile
        ? policy.data.image.localFile.childImageSharp.original.src
        : {},
    },
  }
}

// ---------------------------------------------------------------------
// CONTACT
// ---------------------------------------------------------------------

export const mapContact = contact => {
  return {
    title: contact.data.title,
    subtitle: contact.data.subtitle,
    image: {
      url: contact.data.image.url,
      sizes: contact.data.image.localFile
        ? contact.data.image.localFile.childImageSharp.sizes
        : {},
      src: contact.data.image.localFile
        ? contact.data.image.localFile.childImageSharp.original.src
        : {},
    },
    contents: contact.data.body.map(contact => {
      switch (contact.__typename) {
        case 'PrismicCtContactBodyChannels': {
          return {
            type: contact.slice_type,
            heading: contact.primary.heading,
            channels: contact.items.map(item => {
              return {
                type: item.type,
                channel: item.channel,
                contact: item.contact,
              }
            }),
          }
        }
        case 'PrismicCtContactBodyOffice': {
          return {
            type: contact.slice_type,
            heading: contact.primary.heading,
            contents: contact.items.map(item => {
              return {
                location: item.location,
                address: item.address,
                telephone: item.telephone,
                theme: item.theme,
              }
            }),
          }
        }
        case 'PrismicCtContactBodyPromotion': {
          return {
            type: contact.slice_type,
            icon: {
              url: contact.primary.icon.url,
              sizes: contact.primary.icon.localFile
                ? contact.primary.icon.localFile.childImageSharp.sizes
                : {},
            },
            heading: contact.primary.heading,
            link: contact.primary.link,
            text: contact.primary.link_text,
          }
        }
        case 'PrismicCtContactBodyTextBlock': {
          return {
            type: contact.slice_type,
            heading: contact.primary.heading,
            content: contact.primary.content,
          }
        }
      }
    }),
  }
}

// ---------------------------------------------------------------------
// CAREERS
// ---------------------------------------------------------------------

export const mapCareers = careers => {
  return {
    title: careers.data.title,
    subtitle: careers.data.subtitle,
    video: careers.data.videos
      ? mapVideo(careers.data.videos.document[0].data)
      : {},
    list: careers.data.body.map(data => {
      return data.items.map(career => {
        return mapCareer(career.career_existing.document[0])
      })
    }),
  }
}

export const mapCareer = career => {
  return {
    uid: career.uid,
    filter_location: career.data.filter_location,
    filter_type: career.data.filter_type,
    role: career.data.role,
    description: career.data.description,
    details: career.data.details,
    contact: career.data.contact,
  }
}

// ---------------------------------------------------------------------
// CUSTOMER
// ---------------------------------------------------------------------

export const mapCustomers = data => {
  return data.edges.map(item => {
    return mapCustomer(item.node)
  })
}

export const mapCustomer = customer => {
  return {
    uid: customer.uid,
    title: customer.data.title,
    logo: {
      alt: customer.data.logo.alt,
      url: customer.data.logo.url,
      src: customer.data.logo.localFile
        ? customer.data.logo.localFile.childImageSharp.original.src
        : {},
    },
  }
}

// ---------------------------------------------------------------------
// POLICY
// ---------------------------------------------------------------------

export const mapPolicies = data => {
  return data.edges.map(item => {
    return mapPolicy(item.node)
  })
}

export const mapPolicy = policy => {
  return {
    uid: policy.uid,
    id: policy.id,
    title: policy.data.title,
    subtitle: policy.data.subtitle,
    text: policy.data.body[0].items.map(item => {
      return item.para
    }),
  }
}

// ---------------------------------------------------------------------
// ABOUT
// ---------------------------------------------------------------------

export const mapAbout = data => {
  const about = data.data
  return {
    uid: data.uid,
    image_bg: {
      alt: about.image_bg.alt,
      url: about.image_bg.url,
      sizes: about.image_bg.localFile
        ? about.image_bg.localFile.childImageSharp.sizes
        : {},
      src: about.image_bg.localFile
        ? about.image_bg.localFile.childImageSharp.original.src
        : {},
    },
    title: about.title,
    subtitle: about.subtitle,
    metric_title: about.metric_title,
    metrics: about.metrics.map(item => {
      return {
        metric: item.metric,
        value: item.value,
      }
    }),
    image: {
      alt: about.image.alt,
      url: about.image.url,
      sizes: about.image.localFile
        ? about.image.localFile.childImageSharp.sizes
        : {},
    },
    heading: about.heading,
    content: about.content,
    video: about.videos ? mapVideo(about.videos.document[0].data) : {},
    links_title: about.links_title,
    links: about.links.map(item => {
      return {
        link: item.link,
        uid: item.url.raw.uid,
      }
    }),
  }
}

// ---------------------------------------------------------------------
// VIDEO
// ---------------------------------------------------------------------

export const mapVideo = video => {
  return {
    urls: [
      {
        src: video.url_dash.url,
        // type: 'application/x-mpegURL',
      },
      {
        src: video.url_hls3.url,
        // type: 'application/x-mpegURL',
      },
    ],
    poster: {
      url: video.poster && video.poster.url,
      sizes: video.poster.localFile
        ? video.poster.localFile.childImageSharp.sizes
        : {},
      src: video.poster.localFile
        ? video.poster.localFile.childImageSharp.original.src
        : {},
    },
  }
}

// ---------------------------------------------------------------------
// THINGS
// ---------------------------------------------------------------------

export const mapThings = things => {
  return {
    title: things.data.title,
    subtitle: things.data.subtitle,
    intro: things.data.intro,
    list: things.data.body[0].items.map(thing => {
      return mapThing(thing.thing.document[0])
    }),
  }
}

export const mapThing = thing => {
  return {
    uid: thing.uid,
    type: thing.data.thing_type,
    title: thing.data.title,
    subtitle: thing.data.subtitle,
    logo: {
      url: thing.data.logo && thing.data.logo.url,
      sizes: thing.data.logo.localFile
        ? thing.data.logo.localFile.childImageSharp.sizes
        : {},
      src: thing.data.logo.localFile
        ? thing.data.logo.localFile.childImageSharp.original.src
        : {},
    },
    intro_title: thing.data.intro_title,
    intro: thing.data.intro,
    contents:
      thing.data.body &&
      thing.data.body.map(data => {
        switch (data.__typename) {
          case 'PrismicCtThingBodyVideo':
            return {
              type: data.__typename,
              primary: {
                video_data: mapVideo(data.primary.video_link.document[0].data),
              },
            }
          case 'PrismicCtThingBodyBlock':
            return {
              type: data.__typename,
              items:
                data.items &&
                data.items.map(item => {
                  return {
                    block_title: item.block_title,
                    block_text: item.block_text,
                  }
                }),
            }
          case 'PrismicCtThingBodyQuote':
            return {
              type: data.__typename,
              primary: {
                author: data.primary.author,
                quote: data.primary.quote,
              },
            }
          case 'PrismicCtThingBodyEyecandy':
            return {
              type: data.__typename,
              primary: {
                eyecandy_title: data.primary.eyecandy_title,
                eyecandy_text: data.primary.eyecandy_text,
              },
              items: data.items.map(item => {
                return {
                  candy_title: item.candy_title,
                  candy_text: item.candy_text,
                  candy_image: {
                    url: item.candy_image && item.candy_image.url,
                    sizes: item.candy_image.localFile
                      ? item.candy_image.localFile.childImageSharp.sizes
                      : {},
                    src: item.candy_image.localFile
                      ? item.candy_image.localFile.childImageSharp.original.src
                      : {},
                  },
                }
              }),
            }
          case 'PrismicCtThingBodyTakeaways':
            return {
              type: data.__typename,
              primary: {
                takeaway_title: data.primary.takeaway_title,
                takeaway_text: data.primary.takeaway_text,
              },
              items: data.items.map(item => {
                return {
                  download_title: item.download_title,
                  download_text: item.download_text,
                  download: item.download,
                }
              }),
            }
          default:
            return
        }
      }),
  }
}

// ---------------------------------------------------------------------
// METADATA
// ---------------------------------------------------------------------

export const mapMetaData = props => {
  let uid = null
  let data = null

  if (props.edges) {
    uid = props.edges[0].node.uid
    data = props.edges[0].node.data
  } else {
    uid = props.data.uid
    data = props.data
  }

  let slug = typeof uid !== 'undefined' ? '/' + uidToUrl(uid) : ''
  let url = CONFIG.baseUrl + slug

  return {
    title: data.meta_title,
    description: data.meta_description,
    ogTitle: data.og_title,
    ogDescription: data.og_description,
    ogType: data.og_type,
    ogUrl: url,
  }
}

// ---------------------------------------------------------------------
// PAGE
// ---------------------------------------------------------------------

export const mapPage = page => {
  let topper = getTopper(page)
  let mapper = []
  let contents = []

  if (page.data.body) {
    page.data.body.map(type => {
      mapper.push(type.slice_type)
    })

    contents = page.data.body.map(item => {
      return {
        type: item.slice_type,
        content: item,
      }
    })
  }

  return {
    mapper: mapper,
    topper: topper,
    contents: contents,
  }
}

// ---------------------------------------------------------------------
// ---------------------------------------------------------------------
// ---------------------------------------------------------------------
// HELPERS
// ---------------------------------------------------------------------
// ---------------------------------------------------------------------
// ---------------------------------------------------------------------

const getContents = data => {
  return (
    data.body &&
    data.body.map(item => {
      switch (item.__typename) {
        // case 'PrismicCtServiceFocusBodyText':
        //   return {
        //     type: item.slice_type,
        //     content: item,
        //   }
        // case 'PrismicCtServiceFocusBodyContentLink':
        //   return {
        //     type: item.slice_type,
        //     content: item,
        //   }
        // case 'PrismicCtMethodBodyQuote':
        //   return {
        //     type: item.slice_type,
        //     content: item,
        //   }
        // case 'PrismicCtMethodBodyContentLink':
        //   return {
        //     type: item.slice_type,
        //     content: item,
        //   }
        // case 'PrismicCtMethodBodyList':
        //   return {
        //     type: item.slice_type,
        //     content: item,
        //   }
        // case 'PrismicCtMethodBodyBoxes':
        //   return {
        //     type: item.slice_type,
        //     content: item,
        //   }
        // case 'PrismicCtMethodBodyContact':
        //   return {
        //     type: item.slice_type,
        //     content: item,
        //   }
        // case 'PrismicCtShotBodyQuote':
        //   return {
        //     type: item.slice_type,
        //     content: item,
        //   }
        // case 'PrismicCtShotBodyContent':
        //   return {
        //     type: item.slice_type,
        //     content: item,
        //   }
        // case 'PrismicCtShotBodyContentLink':
        //   return {
        //     type: item.slice_type,
        //     content: item,
        //   }
        // case 'PrismicCtShotBodyContact':
        //   return {
        //     type: item.slice_type,
        //     content: item,
        //   }

        case 'PrismicCtServiceBodyServiceContentLink':
          return {
            type: CONTENTTYPES.contentLink,
            content: item,
          }

        case 'PrismicCtServiceBodyServiceContent':
          return getSections(item, 'PrismicCtServiceBodyServiceContent')
        case 'PrismicCtStudyBodyStudySection':
          return getSections(item, 'PrismicCtStudyBodyStudySection')
        case 'PrismicCtBlogBodyBlogSection':
          return getSections(item, 'PrismicCtBlogBodyBlogSection')
        case 'PrismicCtServiceBodyServiceQuote':
          return getQuote(item, 'PrismicCtServiceBodyServiceQuote')
        case 'PrismicCtStudyBodyStudyQuote':
          return getQuote(item, 'PrismicCtStudyBodyStudyQuote')
        case 'PrismicCtBlogBodyBlogQuote':
          return getQuote(item, 'PrismicCtBlogBodyBlogQuote')
        case 'PrismicCtBlogBodyVideoSlice':
          return getvideo(item, 'PrismicCtBlogBodyVideoSlice')
      }
    })
  )
}

const getvideo = (data, filter) => {
  console.log(data)
  return {
    type: CONTENTTYPES.video,
    video: data.primary.video.document[0].data,
    title: data.primary.video_title,
    subtitle: data.primary.video_subtitle,
  }
}

const getSections = (data, filter) => {
  return {
    type: CONTENTTYPES.section,
    image: data.primary
      ? {
          alt: data.primary && data.primary.section_image.alt,
          sizes: data.primary.section_image.localFile
            ? data.primary.section_image.localFile.childImageSharp.sizes
            : {},
          src: data.primary.section_image.localFile
            ? data.primary.section_image.localFile.childImageSharp.original.src
            : {},
        }
      : null,
    contents: data.items.map(item => {
      return {
        // image: item.section_image
        //   ? {
        //       url: item.section_image && item.section_image.url,
        //       alt: item.section_image && item.section_image.alt,
        //       sizes: item.section_image.localFile
        //         ? item.section_image.localFile.childImageSharp.sizes
        //         : {},
        //     }
        //   : null,
        image: item.section_image
          ? {
              url: item.section_image && item.section_image.url,
              alt: item.section_image && item.section_image.alt,
              src: item.section_image.localFile
                ? item.section_image.localFile.childImageSharp.original.src
                : {},
              sizes: item.section_image.localFile
                ? item.section_image.localFile.childImageSharp.sizes
                : {},
            }
          : null,
        title: item.section_title,
        subtitle: item.section_subtitle,
        text: item.section_text,
      }
    }),
  }
}

const getQuote = (data, filter) => {
  return {
    type: CONTENTTYPES.quote,
    quote: data.primary.quote_text,
    author: data.primary.quote_author,
  }
}

const getTopper = page => {

  let background_image =
    page.data.background_image && !page.data.image
      ? page.data.background_image
      : page.data.image
  let subtitle =
    page.data.title && page.data.headline
      ? page.data.headline
      : page.data.subtitle

  return {
    background_video: page.data.background_video
      ? mapVideo(page.data.background_video.document[0].data)
      : [],
    background_image: {
      src: background_image.localFile
        ? background_image.localFile.childImageSharp.original.src
        : null,
      sizes: background_image.localFile
        ? background_image.localFile.childImageSharp.sizes
        : null,
    },
    gradient: page.data.gradient,
    title: page.data.headline,
    subtitle: subtitle,
    lead: page.data.lead,
    type: page.data.type,
  }
}

const friendlyDate = date => {
  return date
    ? moment(date).format('MMMM Do YYYY')
    : moment().format('MMMM D YYYY')
}

const getAuthor = data => ({
  name: data.author && data.author.document[0].data.author_name,
  role: data.author && data.author.document[0].data.author_role,
})



// WEBPACK FOOTER //
// ./src/utils/mapper.js